module.exports = "<div class=\"help_container\">\n\t<div class=\"help_text\">\n\t\tHaben Sie eine Frage zu leoticket?<br/>\n\t\tUnser Support hilft Ihnen gerne weiter.<br/>\n\t</div>\n\t<div class=\"help_contacts\">\n\t\t<p>\n\t\t\t<a href=\"mailto:support@leoticket.de\">\n\t\t\t\t<span class=\"envelope-icon\" title=\"E-Mail\">\n\t\t\t\t\tsupport@leoticket.de\n\t\t\t\t</span>\n\t\t\t</a>\n\t\t</p>\n\t\t<p>\n\t\t\t<i class=\"phone-icon\" title=\"Telefon\"></i>\n\t\t\t07152 9259 700\n\t\t</p>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/help/help.html
// module id = ckz9
// module chunks = 12